import React from 'react';
import { WalletModalProvider, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import AudioContext from './AudioContext';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';

function LoginPopup({ onClose, connected }) {
  const { wallet } = useSolanaWeb3();

  return (
    <div className="popup-container">
      <div className="popup" id="login">
        <div className="ellipse" id="ellipse-login"></div>
        <h2>Connect Your Wallet</h2>
        <WalletModalProvider>
          <WalletMultiButton />
        </WalletModalProvider>
      </div>
    </div>
  );
}

export default LoginPopup;